import axios from "axios";

// Order CRUD
export const createOrder = async (data) => {
  const response = await axios.post("order", data);
  return response.data;
};

export const getAllOrders = async (params = {}) => {
  const response = await axios.get("order", { params });
  return response.data;
};

export const searchOrderItems = async (params = {}) => {
  const response = await axios.get("order/items/search", { params });
  return response.data;
};

export const getOrderById = async (id) => {
  const response = await axios.get(`order/${id}`);
  return response.data;
};

export const updateOrder = async (id, data) => {
  const response = await axios.put(`order/${id}`, data);
  return response.data;
};

// Order Actions
export const cancelOrder = async (id, reason) => {
  const response = await axios.post(`order/${id}/cancel`, {
    cancellation_reason: reason,
  });
  return response.data;
};

export const cloneOrder = async (id) => {
  const response = await axios.post(`order/${id}/clone`);
  return response.data;
};

export const updateOrderStatus = async (id, status) => {
  const response = await axios.patch(`order/${id}/status`, { status });
  return response.data;
};

export const dispatchOrder = async (id, data) => {
  const response = await axios.post(`order/${id}/dispatch`, {
    challan_number: data.challan_number,
    dispatched_on: data.dispatched_on,
    notes: data.notes,
  });
  return response.data;
};

export const deliverOrder = async (id, data) => {
  const formData = new FormData();
  formData.append("invoice_number", data.invoice_number);
  formData.append("delivered_on", data.delivered_on);
  formData.append("notes", data.notes || "");

  if (data.receiving_image) {
    formData.append("receiving_image", data.receiving_image);
  }

  const response = await axios.post(`order/${id}/deliver`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// Job Management
export const createJobs = async (orderId, itemId, jobConfig) => {
  const response = await axios.post(
    `order/${orderId}/items/${itemId}/job`,
    jobConfig
  );
  return response.data;
};

export const createAllJobs = async (orderId, config = {}) => {
  const response = await axios.post(`order/${orderId}/jobs`, config);
  return response.data;
};

// Kanban Data
export const getKanbanData = async (params = {}) => {
  const response = await axios.get("order/kanban", { params });
  return response.data;
};

// Update individual order-item status (used by Kanban drag-and-drop)
// PATCH /v1/order/:orderId/items/:itemId/status
export const updateItemStatus = async (orderId, itemId, status) => {
  const response = await axios.patch(
    `order/${orderId}/items/${itemId}/status`,
    { status }
  );
  return response.data;
};

export default {
  createOrder,
  getAllOrders,
  searchOrderItems,
  getOrderById,
  updateOrder,
  cancelOrder,
  cloneOrder,
  updateOrderStatus,
  dispatchOrder,
  deliverOrder,
  createJobs,
  createAllJobs,
  getKanbanData,
  updateItemStatus,
};
